<template>
    <div>
        <div class="row">
            <div class="col">
                <bread-nav :assessment-cycle="assessmentCycle"
                           :facility-name="facilityName"
                           :classroom-name="classroomName"
                           :cycle-stage="cycleStage"
                ></bread-nav>
            </div>
        </div>

		<assessment-cycle-version-banner
			:assessment-cycle="assessmentCycle"
		></assessment-cycle-version-banner>

        <div v-if="sectionsUnavailable" class="row mb-2">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        Checking for available sections...
                        <br><br>
                        A section's indicators must be locked in the Followup Assessment before that section will appear here.
                    </div>
                </div>
            </div>
        </div><!-- .row -->
        <div class="row">
            <div class="col-3">
                <div class="card"
                     :class="{ 
                        'section-focus': generalComment == true
                     }"
                >
                    <div id="general_comment_card" class="card-body section-card d-flex justify-content-between" @click="showGeneralComment()">
                        General Comments
                    </div>
                </div>
                <div v-for="section in sections" :key="section.section_number">
                    <div v-if="lockedFollowupSections[section.section_number] && lockedInitialSections[section.section_number]" 
                         class="card mt-2"
                         :class="{ 
                            'section-focus': section.section_number == activeSection.section_number
                         }"
                    >
                        <div :id="'section_'+ section.section_number" class="card-body section-card d-inline-flex" @click="showActiveIndicators(section)">
                            <div>
                                {{ section.section_number }}.
                            </div>
                            <div class="pl-1">
                                {{ section.name }}
                            </div>
                        </div>
                    </div><!-- .card -->
                </div>
            </div>
            <div v-if="!generalComment" id="indicator_list" class="col-9">
                <div v-if="activeSection.section_number">
                    <a :href="'/assessment-cycle/offline?assessment_cycle_id='+ cycle.id +'&stage=summary&section_number='+ activeSection.section_number" 
                        class="btn btn-primary btn-sm float-right"
                    >
                        Offline Form
                    </a>
                    <span class="section-title mr-3">{{ activeSection.section_number }}. &nbsp; {{ activeSection.name }}</span>
                </div>
                <div v-for="indicator in activeIndicators" :key="indicator.id">
                    <summary-indicator :indicator="indicator" :scoring-labels="scoringLabels"></summary-indicator>
                </div>
                <div v-if="activeSection.section_number" class="d-flex flex-column justify-content-center mt-4">
                    <div>
                        <ul>
                            <li>Summary data is saved automatically as you input it</li>
                        </ul>
                    </div>
                    <div>
                        <a :href="'/facilities/'+ cycle.facility_id" class="btn btn-secondary ml-4">Back to Facility Detail</a>
                    </div>
                </div>
            </div>
            <div v-if="generalComment" class="col-9">
                <div id="general_comment">
                    <general-comment
                        :assessment-cycle="assessmentCycle"
                        :assessment-type="cycleStage"
                    ></general-comment>
                </div>
            </div>
        </div><!-- .row -->
    </div>
</template>

<style scoped>
.section-card {
    cursor: pointer;
    padding: 1rem 1rem;
    line-height: 1.4;
}
.section-focus {
    border: 2px solid blue;
}
.section-title {
    font-size: 1.4em;
    font-weight: bold;
}
</style>

<script>
    import SummaryIndicator from '../indicators/SummaryIndicator'
    import BreadNav from '../breadcrumb_navbar/BreadNav'
    import GeneralComment from '../general_comment/GeneralComment'
    import AssessmentCycleVersionBanner from './AssessmentCycleVersionBanner.vue'    
    import { mapState } from 'vuex'

    export default {
        name: "Assessment Summary",

        components: { SummaryIndicator, BreadNav, GeneralComment, AssessmentCycleVersionBanner },

        props: {
            assessmentCycle: Object,
            facilityName: String,
            classroomName: String,
            scoringLabels: Object
        },

        data() {
            return {
                cycleStage: this.$options.name,
                activeIndicators: [],
                activeSection: {},
                generalComment: false
            }       
         },

        methods: {
            showGeneralComment () {
                this.generalComment = true
                this.activeSection = {}
            },
            showActiveIndicators (section) {
                this.generalComment = false
                this.activeSection = section
                this.activeIndicators = this.indicators[section.section_number]
            },
            waitForCycle () {
                this.intervalId = setInterval(() => {
                    if (this.cycle) {
                        clearInterval(this.intervalId)
                        this.fetchData()
                    }
                }, 500)
            },
            fetchData () {
                this.$store.dispatch('cycle/fetchSections')
                this.$store.dispatch('cycle/fetchIndicators')
                this.$store.dispatch('initial/fetchInitialIndicators', {
                    'assessment_cycle_id': this.cycle.id
                })
                this.$store.dispatch('plan/fetchPlanIndicators', {
                    'assessment_cycle_id': this.cycle.id
                })
                this.$store.dispatch('followup/fetchFollowupIndicators', {
                    'assessment_cycle_id': this.cycle.id
                })
                this.$store.dispatch('summary/fetchSummaryIndicators', {
                    'assessment_cycle_id': this.cycle.id
                })
                this.$store.dispatch('general_comment/fetchGeneralComment', {'assessment_cycle_id': this.cycle.id, 'assessment_type': this.cycleStage})
            },
            formatDate (date) {
                return date ? moment(date).format('YYYY-MM-DD') : null
            }            
        },

        computed: {
            ...mapState({
                cycle: state => state.cycle.cycle,
                sections: state => state.cycle.sections,
                indicators: state => state.cycle.indicators,
                followupIndicators: state => state.followup.followupIndicators,
                lockedFollowupSections: state => state.followup.sections.locked,
                lockedInitialSections: state => state.initial.sections.locked,
                summaryGeneralComment: state => state.general_comment.generalComment
            }),
            sectionsUnavailable () {
                return Object.values(this.lockedFollowupSections).includes(true) ? false : true
            }
        },

        mounted () {
            this.$store.dispatch('cycle/setCycle', this.assessmentCycle)
            this.waitForCycle() // using this to overcome asynchrony
        }
    }
</script>
